export default __webpack_public_path__ + "47c32f5fffa089b4a8af8e44ab622faa.jpg";